export { useFetchOutageInfo } from "./useFetchOutageInfo";
export { type OutageAlert, useOutageNotifications } from "./useOutageNotifications";
